<ng-container>
	<div class="desktop">
		<div
			*ngIf="!modeviewadvice && !modeviewavg"
			fxFlex="100"
			fxLayout="row"
			fxLayout.lt-md="column"
			fxLayout.lt-sm="column"
		>
			<div
				fxFlex="70"
				fxFlex.lt-sm="100"
				fxFlex.lt-md="100"
				fxLayout="column"
				class="shot_dialog_content"
			>
				<div fxFlex="100" style="font-weight: bold">
					<aigia-posture-tab
						fxFlex="100"
						(progrssChange)="progrssChange($event)"
						[active]="false"
						[locked]="true"
						[size]="Size(2)"
						[visible]="true"
						[shots]="shots"
					></aigia-posture-tab>
				</div>
				<div fxFlex="100" style="background: #212121">
					<!--		<aigia-ballistic-chart (progrssChange)="progrssChange($event)" [active]="false" [locked]="true" [ngStyle]="{'z-index': 30}" [size]="Size(3)" [visible]="false && isBallistic()" [shots-mongo]="shots-mongo" [name]="Name(3)"></aigia-ballistic-chart> -->
					<aigia-ballistic-tab
						fxFlex="100"
						(progrssChange)="progrssChange($event)"
						[active]="false"
						[locked]="true"
						[size]="Size(4)"
						[visible]="isBallistic()"
						[shots]="shots"
					></aigia-ballistic-tab>
				</div>
			</div>
			<div
				fxFlex="30"
				fxFlex.lt-sm="100"
				fxFlex.lt-md="100"
				fxLayout="column"
				style="background: #212121"
			>
				<aigia-video-table
					fxFlex="50"
					(progrssChange)="progrssChange($event)"
					[active]="false"
					[locked]="true"
					[size]="Size(0)"
					[visible]="true"
					[maxSelected]="1"
					[videos]="smVideosSide.slice(0, 2)"
				></aigia-video-table>
				<aigia-video-table
					fxFlex="50"
					(progrssChange)="progrssChange($event)"
					[active]="false"
					[locked]="true"
					[size]="Size(1)"
					[visible]="true"
					[maxSelected]="1"
					[videos]="smVideosBack.slice(0, 2)"
				></aigia-video-table>
			</div>
		</div>
		<div
			*ngIf="modeviewadvice"
			fxFlex="100"
			fxLayout="row"
			fxLayout.lt-md="column"
			fxLayout.lt-sm="column"
		>
			<div
				fxFlex="100"
				fxFlex.lt-sm="100"
				fxFlex.lt-md="100"
				fxLayout="column"
				class="shot_dialog_content"
			>
				<div fxFlex="100" style="font-weight: bold">
					<aigia-posture-tab
						fxFlex="100"
						(progrssChange)="progrssChange($event)"
						[active]="false"
						[locked]="true"
						[size]="Size(2)"
						[visible]="true"
						[modeviewadvice]="true"
						[shots]="shots"
					></aigia-posture-tab>
				</div>
			</div>
		</div>

		<div
			*ngIf="modeviewavg"
			fxFlex="100"
			fxLayout="row"
			fxLayout.lt-md="column"
			fxLayout.lt-sm="column"
		>
			<div
				fxFlex="100"
				fxFlex.lt-sm="100"
				fxFlex.lt-md="100"
				fxLayout="column"
				class="shot_dialog_content"
			>
				<div fxFlex="100" style="font-weight: bold">
					<aigia-posture-tab
						fxFlex="100"
						(progrssChange)="progrssChange($event)"
						[active]="false"
						[locked]="true"
						[size]="Size(2)"
						[visible]="true"
						[modeviewavg]="true"
						[shots]="shots"
					></aigia-posture-tab>
				</div>
			</div>
		</div>
	</div>
</ng-container>
